<template>
  <div class="my-order all-order-content public-content">
    <div class="breadcrumb">{{info.username}}</div>

    <div class="right-content" style="padding:10px;">
      <div class="main-content" style="background:#F2F2F2;">
        <el-table :data="tableData" class="table-cell" border style="width: 100%" default-expand-all>
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form class="demo-table-expand aaa" label-width="110px">

                <el-form-item v-for="attr in props.row.attrs" :key="attr.attrId" :label="attr.attrCode" style="display:inline-block">
                  <span>{{ attr.attrValue }}</span>
                </el-form-item>
                <el-form-item label="图片" v-show="props.row.images.length!==0">
                  <div>
                    <el-image v-for="(img,index) in props.row.images" :key="img.id" lazy :preview-src-list="getImgList(props.row.imgList,index)"
                      style="width: 85px; height: 85px;border-radius:7px;border:1px solid #000;margin-right:3px;"
                      :src="img.image.url+'?x-sds-process=image/resize,l_83,m_mfit'" fit="contain"></el-image>
                  </div>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column label="模板页名称" prop="moduleName"></el-table-column>
        </el-table>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      info: {},
      tableData: [{}]
    }
  },
  created () {
    this.info = JSON.parse(this.$route.query.info)
    this.init()
  },
  methods: {
    getImgList (imgList, index) {
      return imgList.slice(index).concat(imgList.slice(0, index))
    },
    init () {
      let idList = []
      let moduleList = []
      let obj = {}
      this.info.attrs.forEach(attr => {
        idList.push(attr.moduleId)
      })
      this.info.customerImages.forEach(item => {
        idList.push(item.moduleId)
      })
      idList = Array.from(new Set(idList))

      idList.forEach(id => {
        let obj = {
          attrs: [],
          images: [],
          imgList: [],
          moduleId: id,
          moduleName: ''
        }

        obj.attrs = this.info.attrs.filter(attr => {
          if (attr.moduleId === id) {
            obj.moduleName = attr.moduleName
          }
          return attr.moduleId === id
        })

        obj.images = this.info.customerImages.filter(item => {
          if (item.moduleId === id) {
            obj.moduleName = item.moduleName
          }
          return item.moduleId === id
        })
        obj.imgList = obj.images.reduce((list, item) => {
          list.push(item.image.url)
          return list
        }, [])

        moduleList.push(obj)
      })

      this.tableData = moduleList
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
